import {ACTION_TYPE} from "utils/constants";

export const setGameState = option => ({
  type: ACTION_TYPE.SET_GAME_STATE,
  payload: option,
});

export const sendGameMessage = message => ({
  type: ACTION_TYPE.SEND_GAME_MESSAGE,
  payload: message,
});

export const receiveGameMessage = message => ({
  type: ACTION_TYPE.RECEIVE_GAME_MESSAGE,
  payload: message,
});
